module.exports = __webpack_public_path__ + "img/107.0531b127.png";